import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Stack } from "@atlaskit/primitives";
import { boxStyles } from "./utils/wizardstyles";
import {setWizardPage,setWizard}  from "../redux/actions/wizardActions"
const WizardItem = ({tutorial}) => {
  const dispatch = useDispatch();
  const onClick = () => {
    dispatch(setWizardPage(1))
    dispatch(setWizard(tutorial))
  };
  return (
    <Box xcss={boxStyles} as="li" onClick={onClick}>
      {tutorial.icon}
      {tutorial.title}
      <Stack space="space.100">
        <Box as="span">{tutorial.description}</Box>
      </Stack>
    </Box>
  );
};
export default WizardItem;
